import { downloadBlob } from "~/utils/file";

const ClipAPI = {
  async download(event: IModelEvent) {
    if (!event.source.clip)
      return;

    try {
      const response = await $fetch<ArrayBuffer>(event.source.clip,
        { responseType: "arrayBuffer" },
      );
      const blob = new Blob([response], { type: "octet/stream" });
      const fileName = event.title ? `${event.title}.mp4` : `${event.team1Name} VS ${event.team2Name}.mp4`;
      downloadBlob(fileName, blob);
    } catch (err) {
      console.error(err);
    }
  },
};

export default ClipAPI;
